import * as React from "react"
import { Input } from "./input"
import { cn } from "../../lib/utils"

export interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  description?: string
  error?: string
}

const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  ({ 
    label, 
    description, 
    error, 
    id,
    className,
    ...props 
  }, ref) => {
    const inputId = id || React.useId()

    const inputElement = (
      <Input
        id={inputId}
        className={cn(
          error && "border-destructive focus-visible:ring-destructive",
          className
        )}
        ref={ref}
        aria-describedby={description ? `${inputId}-description` : undefined}
        aria-invalid={error ? true : undefined}
        {...props}
      />
    )

    if (label || description || error) {
      return (
        <div className="space-y-2">
          {label && (
            <label htmlFor={inputId} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-foreground">
              {label}
            </label>
          )}
          {inputElement}
          {description && (
            <p id={`${inputId}-description`} className="text-sm text-muted-foreground">
              {description}
            </p>
          )}
          {error && (
            <p className="text-sm text-destructive">
              {error}
            </p>
          )}
        </div>
      )
    }

    return inputElement
  }
)
InputField.displayName = "InputField"

export { InputField } 